import { render } from "./ModalProductAddedToCart.vue?vue&type=template&id=1fa97c4e&scoped=true"
import script from "./ModalProductAddedToCart.vue?vue&type=script&lang=js"
export * from "./ModalProductAddedToCart.vue?vue&type=script&lang=js"

import "./ModalProductAddedToCart.vue?vue&type=style&index=0&id=1fa97c4e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa97c4e"]])

export default __exports__